<form class="ui-g form-style" #loginForm="ngForm" novalidate>
    <button pButton type="button" [icon]="icon" styleClass="p-button-secondary"
    *ngIf="resetPasswordMode || forgotPasswordMode ||verificationMode"
        (click)="backToLogin()">
    </button>

    <div *ngIf="!forgotPasswordMode && !verificationMode && !resetPasswordMode">
        <div class="r-form-group">
            <label class="title" for="email">{{'LOGIN.USEREMAIL' | translate}}</label>
            <input type="email" autocomplete="off" name="email" #email="ngModel" [(ngModel)]="loginModel.email"
                (keyup.enter)="doLogin()" (change)="changeStatusInvalidLogin()" required>
            <div *ngIf="loginForm.submitted && !email.valid" class="error-required">
                {{'ERRORS.REQUIRED' | translate}}
            </div>
        </div>
        <div class="r-form-group divPassword">
            <label class="title">{{'LOGIN.PASSWORD.PASSWORD' | translate}}</label>
            <p-password class="inputPassword" type="password" autocomplete="off" name="password"
                (keyup.enter)="doLogin()" [(ngModel)]="loginModel.password" #password="ngModel"
                (change)="changeStatusInvalidLogin()" [toggleMask]="true" [feedback]="false" required>
            </p-password>
            <div *ngIf="loginForm.submitted && !password.valid" class="error-required">
                {{'ERRORS.REQUIRED' | translate}}
            </div>
        </div>
       
        <a class="link forgot-password" (click)="forgotPassword()">{{'LOGIN.FORGOT_PASSWORD' | translate}}</a>
    </div>

    <div class="form-divider" *ngIf="!forgotPasswordMode && !verificationMode && !resetPasswordMode"></div>

    <div *ngIf="!forgotPasswordMode && !verificationMode && !resetPasswordMode">
        <div id="googleSignInButton" class="custom-google-button"></div>
    </div>

    <div *ngIf="!forgotPasswordMode && !verificationMode && !resetPasswordMode">
        <button type="submit" class="command-button full full-width" [disabled]="!loginForm.form.valid"
        (click)="doLogin()">
        {{'LOGIN.LOGIN' | translate}}
        </button>
    </div>

    <div class="invalidLogin" *ngIf="invalidLogin">{{'LOGIN.MESSAGES.INVALID_USER_OR_PASSWORD'|translate}}</div>
    <div class="invalidLogin" *ngIf="invalidLoginByGoogle">{{'LOGIN.MESSAGES.INVALID_LOGIN_BY_GOOGLE'|translate}}</div>

    <div *ngIf="forgotPasswordMode">
        <div class="r-form-group divPassword">
            <label class="title">{{'LOGIN.PASSWORD.EMAIL_CODE_VERTIFICATION' | translate}}</label>
            <input name="emailReset" type="email" [(ngModel)]="resetEmail" required>
            <div *ngIf="userNotFound"  class="error-required">
                {{ 'LOGIN.PASSWORD.MESSAGES.MANAGER_NOT_FOUND' | translate }}
            </div>
            <button class="password command-button full full-width" (click)="sendVerificationCode()">
                {{'LOGIN.PASSWORD.SEND_CODE' | translate}}
            </button>
        </div>
    </div>

    <div *ngIf="verificationMode">
       <div class=" r-form-group">
        <label class="title">{{'LOGIN.PASSWORD.ENTER_CODE' | translate}}</label>
        <input type="text" name="verificationCode" [(ngModel)]="verificationCode" required>
        <div *ngIf="passwordNotCorrect"  class="error-required">
            {{'LOGIN.PASSWORD.MESSAGES.INVALID_VERIFICATION_CODE' | translate }}
        </div>
        <button class="password command-button full full-width" (click)="verifyCode()">
            {{'LOGIN.PASSWORD.VERIFY' | translate}}
        </button>
        </div>
        <a class="link forgot-password" (click)="sendEmailAgain()">{{'LOGIN.PASSWORD.SEND_AGAIN' | translate}}</a>
    </div>
    <div *ngIf="resetPasswordMode">
        <div class=" r-form-group">
        <label class="title">{{'LOGIN.PASSWORD.NEW_PASSWORD' | translate}}</label>
        <p-password 
            name="newPassword" 
            [feedback]="false" 
            toggleMask 
            [(ngModel)]="newPassword" 
            required>
        </p-password>
    </div>
    <div class=" r-form-group">

        <label class="title">{{'LOGIN.PASSWORD.CONFIRM_PASSWORD' | translate}}</label>
        <p-password 
            name="verifyNewPassword" 
            [feedback]="false" 
            toggleMask 
            [(ngModel)]="confirmPassword" 
            required>
        </p-password>
    </div>
        <div *ngIf="confirmPassword && newPassword !== confirmPassword" class="error-required">
            {{ 'CHANGE_PASSWORD.DONT_MATCH' | translate }}
        </div>
        <button class="password command-button full full-width" (click)="resetPassword()">
            {{'LOGIN.PASSWORD.RESET_PASSWORD' | translate}}
        </button>  
    </div> 
</form>
